export const API_PATH_ApiLanePlanningPut = '/services/lane-planning/apiLanePlanningPut';
